import Personal from './components/changePersonalInfo';
import Header from './index.vue';
import newStoreHeader from './newStore.vue';
import StoreHeader from './store.vue';
export { Header, StoreHeader, newStoreHeader, Personal };



// WEBPACK FOOTER //
// ./src/components/Header/index.js